import type { ModalInstance } from '../../../contexts/ModalContext';
import type {
  ContentObjectCustomValidateFn,
  ContentObjectSubmitFn,
} from '../../../form/ContentObjectForm/ContentObjectForm';
import type {
  ContentTypeDefinition,
  PluginContentObject,
  WithOptionalInternalProps,
} from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

/**
 * Additional options passed to settings form.
 *
 * @memberof FlotiqPlugins.Events
 */
export type SchemaEventResponseOptions = {
  /** Custom validate on form data change. */
  onValidate?: ContentObjectCustomValidateFn;
  /** Custom submit handler. */
  onSubmit?: ContentObjectSubmitFn;
  /**
   * If build in validation should be disabled.
   * If build in validation is disabled, the validation has to be handled by onValidate option.
   */
  disabledBuildInValidation?: boolean;
};

/**
 * Expected response from event that will generate form.
 *
 * @memberof FlotiqPlugins.Events
 */
export type SchemaEventResponse = {
  /** Schema object compatible with Flotiq API. All passed schema gets nonCtdSchema value set on true. */
  schema: WithOptionalInternalProps<ContentTypeDefinition>;
  /** Additional options passed to settings form. */
  options?: SchemaEventResponseOptions;
};

type PluginsManageFormSchemaEventInit = {
  /** Plugin data */
  plugin: PluginContentObject;
  /** Content types data */
  contentTypes: ContentTypeDefinition[];
  /** Settings modal instance with resolve method */
  modalInstance: ModalInstance;
  /** Callback for reloading plugin settings */
  reload: () => void;
};

/**
 * An event that is fired on manage button click.
 * Returning object will be used to generate manage form for plugin settings.
 * A plugin will not receive this event when manage button is clicked for any other plugin.
 *
 * @eventName "flotiq.plugins.manage::form-schema"
 * @memberof FlotiqPlugins.Events
 * @returns {null|SchemaEventResponse}
 */

export class PluginsManageFormSchemaEvent extends IFlotiqPluginEvent {
  constructor(initData: PluginsManageFormSchemaEventInit) {
    super(initData);
  }
}
